/**Cấu hình caching data useQuery trong 5 phút */
export const configKeepData5Mins = {
    staleTime: 1000 * 60 * 5,
};

/**
 * Cấu hình giữ data trong (n) phút được truyền vào
 * @default 5 phút
 *  */
export const configKeepDataIn = (num?: number) => {
    num ??= 5;
    return {
        staleTime: 1000 * 60 * num,
    };
};

/**Cấu hình caching data useQuery cho đến khi reload lại web */
export const configKeepDataInfiniy = {
    staleTime: Infinity,
};

/**Cấu hình không giữ lại data query trước đó */
export const configNoPreviousDataQuery = {
    gcTime: 0,
};
